import LoadingFilledSVG from './icon_loading_filled.svg';
import withIconProps from './withIconProps';

export default withIconProps(LoadingFilledSVG);
